export class NewTax
{
    public taxObject : TaxObject;
    public taxLocationObjects : TaxLocationObjects[];
}

export class TaxObject
{
    public Id : number;
    public Name: string;
    public Percentage: number;
    public IsIncludedInPrice: boolean;
    public Enabled: boolean;
    public ApplyToCustomAmount: boolean;
    public CreatedBy: number;
    public CreatedDate : Date; 
    public UpdatedBy: number;
    public UpdatedDate: Date;
    public IsDeleted: boolean;
    public IsAvailableToFutureLoc: boolean;
}

export class TaxLocationObjects
{
    public TaxId: number;
    public LocationId: number;
}

export class TaxSummaryRate
{
    public Id: number;
    public CountryCode: string;
    public Country: string;
    public RegionCode: string;
    public Region: string;
    public MinimumLabel: string;
    public MinimumRate: number;
    public AverageLabel: string;
    public AverageRate: number;
    public CreatedBy: number;
    public CreatedDate: Date;
    public UpdatedBy: number;
    public UpdatedDate: Date;
}

export class TaxOrder
{
    public FromCountry: string; //2-letter ISO country code;optional
    public FromZip: string; //5-Digit ZIP or ZIP+4;optional
    public FromState: string; //2-letter ISO state code;optional
    public FromCity: string; //optional
    public FromStreet: string; //optional
    public ToCountry: string; //2-letter ISO country code;required
    public ToZip: string; //required if ToCountry is US
    public ToState: string; //2-letter ISO state code;required if ToCountry is US or CA
    public ToCity: string; //optional
    public ToStreet: string; //optional
    public Amount: number; //either Amount or LineItems are required
    public Shipping: number; //required
    public CustomerId: string; //optional
    public ExemptionType: string;
    public nexusAddress: NexusAddress[];
    public lineItem: LineItem[];
}

export class NexusAddress {
    public Id: string; //optional
    public Country: string; //2-letter ISO country code;required
    public Zip: string; //optional
    public State: string; //2-letter ISO state code;required
    public City: string; //optional
    public Street: string; //optional
}

export class LineItem {
    public Id: string; //Unique identifier of the given line item.Duplicate item IDs within line_items[] will be ignored. optional
    public Quantity: number; //optional
    public ProductTaxCode: string;//optional.If omitted, the item will remain fully taxable.
    public UnitPrice: number; //optional
    public Discount: number; //optional 
}